module.exports = __webpack_public_path__ + "static/media/add.d0f5911d.svg";